
import React from 'react';
import { connect } from 'react-redux';
import { getTransactions, savePortalUser, getPortalUser, sendQrAdvice, sendQrReversal } from '../actions/actions'
import 'antd/dist/antd.css';
import { Table, Button, message } from 'antd';
import { Resizable } from 'react-resizable';
import PaginationComponent from './PaginationComponent';


const ResizeableTitle = props => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable width={width} height={0} onResize={onResize}>
            <th {...restProps} />
        </Resizable>
    );
};


class TransactionTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    title: 'Date',
                    dataIndex: 'date',
                    width: 150,
                },
                {
                    title: 'Customer Email',
                    dataIndex: 'email',
                    width: 200,
                },
                {
                    title: 'Customer Id',
                    dataIndex: 'customerId',
                    width: 200
                },
                {
                    title: 'Transaction Ref',
                    dataIndex: 'transactionRef',
                    width: 180,
                },
                {
                    title: 'Transaction Type',
                    dataIndex: 'transactionType',
                    width: 150,
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    width: 100,
                },
                {
                    title: 'QT Response Code',
                    dataIndex: 'qtResponseCode',
                    width: 100,
                },
                {
                    title: 'Webpay Response Code',
                    dataIndex: 'webpayResponseCode',
                    width: 100,
                },
                {
                    title: 'Transaction Response',
                    dataIndex: 'transactionResponse',
                    width: 200,
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    width: 180,
                },
                {
                    title: 'Reversal Status',
                    dataIndex: 'reversalStatus',
                    width: 180,
                },
                {
                    title: 'Reversal Response Description',
                    dataIndex: 'reversalResponseDescription',
                    width: 180,
                },
                {
                    title: 'Action',
                    key: 'action',
                    render: (record) => (
                        <div className="action-buttons">
                            <Button className="action-button" type="primary" disabled={record.isRepushable ? false : true} onClick={() => this.onRepushClick(record)}>Repush</Button>
                            <Button className="action-button" type="danger" disabled={record.isReversable ? false : true} onClick={() => this.onReverseClick(record)}>Reverse</Button>
                        </div>
                    ),
                },
            ],
            data: [],
            pageSize: 20,
            pageNo: 1,
            total: 500
        };

        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.onPaginationChange = this.onPaginationChange.bind(this);
        this.failAction = this.failAction.bind(this);
        this.onRepushClick = this.onRepushClick.bind(this);
        this.failAdviceAction = this.failAdviceAction.bind(this);
        this.successAdviceAction = this.successAdviceAction.bind(this);
    }


    componentDidMount() {
        const payload = {
            data: {
                transactionReference: '',
                customerEmail: '',
                paymentReference: '',
                customerId: '',
                status: '',
                startDate: '',
                endDate: '',
                pageNo: 1,
                pageSize: 20
            },
            failAction: this.failAction
        }
        this.props.getTransactions(payload);
        this.props.getPortalUser();
    }

    componentDidUpdate(prevProps) {
        const { transactions } = this.props;

        if (transactions !== prevProps.transactions) {
            this.setState({
                data: transactions,
            });
        }
    }


    components = {
        header: {
            cell: ResizeableTitle,
        },
    };

    failAction() {
        message.error("Error processing request at the moment, please try again");
    }

    handleResize = index => (e, { size }) => {
        this.setState(({ columns }) => {
            const nextColumns = [...columns];
            nextColumns[index] = {
                ...nextColumns[index],
                width: size.width,
            };
            return { columns: nextColumns };
        });
    };

    handlePageSizeChange(value) {
        if (value > this.props.paginationData.pageCount) {
            const newPayload = { ...this.props.searchParam };
            newPayload.pageSize = Number(value);
            newPayload.pageNo = this.props.pageCount;
            this.setState({
                pageSize: newPayload.pageSize,
                pageNo: newPayload.pageNo
            });
            const payload = {
                data: newPayload,
                failAction: this.failAction
            }
            this.props.getTransactions(payload);
        } else {
            const newPayload = { ...this.props.searchParam };
            newPayload.pageSize = Number(value);
            this.setState({
                pageSize: newPayload.pageSize
            });
            const payload = {
                data: newPayload,
                failAction: this.failAction
            }
            this.props.getTransactions(payload);
        }
    }

    onPaginationChange(value) {
        const newPayload = { ...this.props.searchParam };
        newPayload.pageNo = Number(value);
        this.setState({
            pageNo: newPayload.pageNo
        });
        const payload = {
            data: newPayload,
            failAction: this.failAction
        }
        this.props.getTransactions(payload);
    }

    failAdviceAction(error) {
        message.error(error);
    }

    successAdviceAction(success) {
        console.log("Inside siuccess advice component ", success);
        message.success(success);
        const payload = this.props.searchParam;
        this.props.getTransactions(payload);
    }

    onRepushClick(record) {

        if (!this.props.user) {
            // this.props.savePortalUser({
            //     id: 1123,
            //     email: "godsman.omeire@interswitchgroup.com"
            // });
            this.props.getPortalUser();
            message.error("Error Getting Initiator, Try Again");
        } else {
            const data = {
                transactionRef: record.transactionRef,
                isRepushable: true,
                passportId: this.props.user.id.toString(),
                passportEmail: this.props.user.email
            }
            this.props.sendQrAdvice({ data, failAdviceAction: this.failAdviceAction, successAdviceAction: this.successAdviceAction });
        }
    }

    onReverseClick(record) {

        if (!this.props.user) {
            // this.props.savePortalUser({
            //     id: 1123,
            //     email: "godsman.omeire@interswitchgroup.com"
            // });
            this.props.getPortalUser();
            message.error("Error Getting Initiator, Try Again");
        } else {
          
            const transactionRef = record.transactionRef
            const userEmail =  this.props.user.email
            this.props.sendQrReversal({ transactionRef, userEmail, failAdviceAction: this.failAdviceAction, successAdviceAction: this.successAdviceAction });
        }
    }


    render() {
        // console.log("Props:", this.props);
        const { loading, paginationData, tableLoading } = this.props;
        const columns = this.state.columns.map((col, index) => ({
            ...col,
            onHeaderCell: column => ({
                width: column.width,
                onResize: this.handleResize(index),
            }),
        }));

        return <section>
            <PaginationComponent onPaginationChange={(item) => this.onPaginationChange(item)} handlePageSizeChange={this.handlePageSizeChange} loading={loading} pageSize={paginationData.pageSize} total={paginationData.dataSize} showPageSize={true} />
            <Table
                bordered components={this.components}
                columns={columns}
                dataSource={this.state.data}
                loading={loading || tableLoading}
                pagination={false} />
            <PaginationComponent onPaginationChange={(item) => this.onPaginationChange(item)} handlePageSizeChange={this.handlePageSizeChange} loading={loading} pageSize={paginationData.pageSize} total={paginationData.dataSize} showPageSize={false} />
        </section>
    }
}

const mapStateToProps = (state) => {
    return {
        transactions: state.transactions,
        loading: state.loading,
        tableLoading: state.tableLoading,
        searchParam: state.searchParam,
        paginationData: state.paginationData,
        user: state.user
    }
}

export default connect(mapStateToProps, { getTransactions, savePortalUser, getPortalUser, sendQrAdvice, sendQrReversal })(TransactionTable);